{
  "(JPEG or PNG)": "(JPEG or PNG)",
  "... Calculating Recipients": "... Calculating Recipients",
  "1. Edit Campaign Details": "1. Edit Campaign Details",
  "1. Edit Template Details": "1. Edit Template Details",
  "2. Edit Email": "2. Edit Email",
  "<0>Get started by creating a <2>New Campaign</2></0>": "<0>Get started by creating a <2>New Campaign</2></0>",
  "<0>This will be your <1>{{campaignsUsed}}</1> campaign this month <4>({{remaining}} remaining).</4></0>": "<0>This will be your <1>{{campaignsUsed}}</1> campaign this month <4>({{remaining}} remaining).</4></0>",
  "A weird error occurred. System templates cannot be sent.": "A weird error occurred. System templates cannot be sent.",
  "Add Filter": "Add Filter",
  "Add Your Company Logo": "Add Your Company Logo",
  "Add banner image<1></1>(optional)": "Add banner image<1></1>(optional)",
  "Add call to action button": "Add call to action button",
  "Add company logo<1></1>(optional)": "Add company logo<1></1>(optional)",
  "Add criteria to select the right recipients.": "Add criteria to select the right recipients.",
  "Alright, I generated this email campaign. What do you think?": "Alright, I generated this email campaign. What do you think?",
  "An error occurred while generating content for your email.": "An error occurred while generating content for your email.",
  "An unexpected error occurred while trying to save. Please try again later.": "An unexpected error occurred while trying to save. Please try again later.",
  "An unexpected error occurred while trying to send your campaign. Please try again later.": "An unexpected error occurred while trying to send your campaign. Please try again later.",
  "Apply to Campaign": "Apply to Campaign",
  "Apply your filter to an email campaign.": "Apply your filter to an email campaign.",
  "Are you sure you want to delete <1>{{name}}</1>?": "Are you sure you want to delete <1>{{name}}</1>?",
  "Are you sure you want to delete <2>{{filterToDelete}}</2>?": "Are you sure you want to delete <2>{{filterToDelete}}</2>?",
  "Are you sure you'd like to delete this draft?": "Are you sure you'd like to delete this draft?",
  "Are you sure you'd like to delete this scheduled campaign?": "Are you sure you'd like to delete this scheduled campaign?",
  "Are you sure you'd like to delete this {{type}}": "Are you sure you'd like to delete this {{type}}",
  "Back": "Back",
  "Back to Campaigns": "Back to Campaigns",
  "Based on the data you entered, I created this campaign. What would you like to do?": "Based on the data you entered, I created this campaign. What would you like to do?",
  "Between <2>{{startDisplayDate}}</2> and <6>{{endDisplayDate}}</6>": "Between <2>{{startDisplayDate}}</2> and <6>{{endDisplayDate}}</6>",
  "Blank document": "Blank document",
  "Business Information": "Business Information",
  "Button Links To": "Button Links To",
  "Button Settings": "Button Settings",
  "Button Text": "Button Text",
  "CSV Only": "CSV Only",
  "Campaign Name": "Campaign Name",
  "Campaigns": "Campaigns",
  "Cancel": "Cancel",
  "Changes made here will update global email settings.": "Changes made here will update global email settings.",
  "Clicks": "Clicks",
  "Close": "Close",
  "Collapse Card": "Collapse Card",
  "Confirm": "Confirm",
  "Content for your email goes here": "Content for your email goes here",
  "Create Campaign": "Create Campaign",
  "Create Campaign from Template": "Create Campaign from Template",
  "Create New Email Campaign": "Create New Email Campaign",
  "Create Suggestions": "Create Suggestions",
  "Create new filter and give it a name": "Create new filter and give it a name",
  "Created By": "Created By",
  "Created New Draft": "Created New Draft",
  "Creating New Campaign Draft...": "Creating New Campaign Draft...",
  "Criteria": "Criteria",
  "Custom date and time": "Custom date and time",
  "Date": "Date",
  "Date Created": "Date Created",
  "Delete": "Delete",
  "Delete Filter": "Delete Filter",
  "Description": "Description",
  "Details": "Details",
  "Discard": "Discard",
  "Don't show this page again.": "Don't show this page again.",
  "Download Example": "Download Example",
  "Draft successfully deleted": "Draft successfully deleted",
  "Drafts": "Drafts",
  "Drag an image (jpg, png) or <2>click here</2> to replace your current logo.": "Drag an image (jpg, png) or <2>click here</2> to replace your current logo.",
  "Drag file here or click to upload": "Drag file here or click to upload",
  "Drag image here or<1>click to upload</1>(JPEG or PNG)": "Drag image here or<1>click to upload</1>(JPEG or PNG)",
  "Drag your logo here or": "Drag your logo here or",
  "Edit": "Edit",
  "Edit Campaign": "Edit Campaign",
  "Edit Filter": "Edit Filter",
  "Edit Template": "Edit Template",
  "Email": "Email",
  "Email Headline": "Email Headline",
  "Email Marketing Filters": "Email Marketing Filters",
  "Email Marketing Settings": "Email Marketing Settings",
  "Email Subject": "Email Subject",
  "Email addresses": "Email addresses",
  "Email filters allow you to send an email campaign to the right recipients, worry free.": "Email filters allow you to send an email campaign to the right recipients, worry free.",
  "Email filters tutorial video": "Email filters tutorial video",
  "Enter URL or email": "Enter URL or email",
  "Enter Your Business Information": "Enter Your Business Information",
  "Exclude": "Exclude",
  "Excludes": "Excludes",
  "Expand Card": "Expand Card",
  "Failed To Create Draft": "Failed To Create Draft",
  "Failed to create filter": "Failed to create filter",
  "Failed to create new draft": "Failed to create new draft",
  "Failed to delete filter": "Failed to delete filter",
  "Failed to delete media": "Failed to delete media",
  "Failed to delete scheduled campaign.": "Failed to delete scheduled campaign.",
  "Failed to delete template": "Failed to delete template",
  "Failed to load image.": "Failed to load image.",
  "Failed to reschedule campaign.": "Failed to reschedule campaign.",
  "Failed to send test email.": "Failed to send test email.",
  "Failed to update filter": "Failed to update filter",
  "File size is too large. Please upload a file less than 10MB.": "File size is too large. Please upload a file less than 10MB.",
  "Filter Applied": "Filter Applied",
  "Filter Discarded. ": "Filter Discarded. ",
  "Filter Name": "Filter Name",
  "Filter Setup 101": "Filter Setup 101",
  "Filters": "Filters",
  "Gallery": "Gallery",
  "Get Started!": "Get Started!",
  "Greetings, {{firstName}}!": "Greetings, {{firstName}}!",
  "Having problems? Looking for inspiration? Want to learn how to get the most out of email filters? Visit the <2>Weave Help page</2> to dive deeper!": "Having problems? Looking for inspiration? Want to learn how to get the most out of email filters? Visit the <2>Weave Help page</2> to dive deeper!",
  "Hello {{firstName}}!": "Hello {{firstName}}!",
  "Here are some subject line ideas and email body text for your campaign. How would you like to proceed?": "Here are some subject line ideas and email body text for your campaign. How would you like to proceed?",
  "Here's some subject suggestions and body text for your email campaign. What would you like to do?": "Here's some subject suggestions and body text for your email campaign. What would you like to do?",
  "Here's your current email campaign. What would you like to do?": "Here's your current email campaign. What would you like to do?",
  "Hey there, {{firstName}}!": "Hey there, {{firstName}}!",
  "Hi {{firstName}}!": "Hi {{firstName}}!",
  "I can help you create a great email campaign. Write out some ideas, topics, or details to get started.": "I can help you create a great email campaign. Write out some ideas, topics, or details to get started.",
  "I can help you improve your campaign. What would you like to do?": "I can help you improve your campaign. What would you like to do?",
  "I've got a few ideas for an interesting email campaign. What ideas, topics, or details should we include?": "I've got a few ideas for an interesting email campaign. What ideas, topics, or details should we include?",
  "Ideas, topics, details...": "Ideas, topics, details...",
  "Import a CSV file with up to {{limit}} email addresses.": "Import a CSV file with up to {{limit}} email addresses.",
  "Include": "Include",
  "Include data from this email campaign": "Include data from this email campaign",
  "Includes": "Includes",
  "Indent": "Indent",
  "Insert Emoji": "Insert Emoji",
  "Legacy Email Marketing has been deprecated. Please use the <2>New Email Marketing!</2>": "Legacy Email Marketing has been deprecated. Please use the <2>New Email Marketing!</2>",
  "Legacy Email Marketing has been deprecated. Please use the New Email Marketing!": "Legacy Email Marketing has been deprecated. Please use the New Email Marketing!",
  "Legacy Email Marketing was shut down on September 16, 2025. Your legacy campaigns and templates are temporarily available for a limited time. Try out the <2>New Weave Email Marketing</2> experience. It is ready for you to use today!": "Legacy Email Marketing was shut down on September 16, 2025. Your legacy campaigns and templates are temporarily available for a limited time. Try out the <2>New Weave Email Marketing</2> experience. It is ready for you to use today!",
  "Let's create an email campaign together. Enter the subject, some topics, or as many details as you'd like.": "Let's create an email campaign together. Enter the subject, some topics, or as many details as you'd like.",
  "Let's generate an email that stands out. What are some ideas, topics, or details you'd like to include?": "Let's generate an email that stands out. What are some ideas, topics, or details you'd like to include?",
  "Let's improve your campaign. Where would you like to start?": "Let's improve your campaign. Where would you like to start?",
  "Let's make the perfect email campaign. Start by entering some ideas, topics, or details.": "Let's make the perfect email campaign. Start by entering some ideas, topics, or details.",
  "Let's make the perfect email campaign. What would you like to change?": "Let's make the perfect email campaign. What would you like to change?",
  "Load More...": "Load More...",
  "Name": "Name",
  "New": "New",
  "New Campaign": "New Campaign",
  "Next": "Next",
  "Next 14 Days": "Next 14 Days",
  "Next 30 Days": "Next 30 Days",
  "Next 7 Days": "Next 7 Days",
  "Next Wednesday at 8:00am": "Next Wednesday at 8:00am",
  "No Filter": "No Filter",
  "No Image": "No Image",
  "No Message": "No Message",
  "No Subject": "No Subject",
  "Note: Only 3 emails can be added.": "Note: Only 3 emails can be added.",
  "Note: your CSV file should be a single column containing email addresses, with a column header titled \"email\".": "Note: your CSV file should be a single column containing email addresses, with a column header titled \"email\".",
  "Opens": "Opens",
  "Optimal image dimensions are 640px x 340px.": "Optimal image dimensions are 640px x 340px.",
  "Our service is busy for the moment. Please try again.": "Our service is busy for the moment. Please try again.",
  "Please enter all required information.": "Please enter all required information.",
  "Please fill out all the required fields.": "Please fill out all the required fields.",
  "Preview": "Preview",
  "Preview failed. Please try again.": "Preview failed. Please try again.",
  "Ready to enhance your campaign? Let me know where you'd like to begin.": "Ready to enhance your campaign? Let me know where you'd like to begin.",
  "Recipients": "Recipients",
  "Redo": "Redo",
  "Reply To Email Address": "Reply To Email Address",
  "Reschedule": "Reschedule",
  "Reschedule Campaign": "Reschedule Campaign",
  "Reuse": "Reuse",
  "Save": "Save",
  "Save Changes": "Save Changes",
  "Save Template": "Save Template",
  "Saving will replace the logo in your settings.": "Saving will replace the logo in your settings.",
  "Schedule": "Schedule",
  "Schedule Email Campaign?": "Schedule Email Campaign?",
  "Schedule Send": "Schedule Send",
  "Scheduled": "Scheduled",
  "Scheduled For": "Scheduled For",
  "Scheduling an email is unavailable for imported emails": "Scheduling an email is unavailable for imported emails",
  "Select A Template": "Select A Template",
  "Select Recipients": "Select Recipients",
  "Select a Filter": "Select a Filter",
  "Select a filter based on your target demographic. Only one filter may be selected, but a single filter can have multiple criteria.": "Select a filter based on your target demographic. Only one filter may be selected, but a single filter can have multiple criteria.",
  "Select all recipients": "Select all recipients",
  "Select an Emoji": "Select an Emoji",
  "Select {{label}}": "Select {{label}}",
  "Send": "Send",
  "Send Email": "Send Email",
  "Send Email Campaign?": "Send Email Campaign?",
  "Send Test Email": "Send Test Email",
  "Send a test email before sending to all your patients.": "Send a test email before sending to all your patients.",
  "Sent": "Sent",
  "Sent Date": "Sent Date",
  "Sent email campaigns will appear here.": "Sent email campaigns will appear here.",
  "Sent {{count}} test emails._one": "Sent {{count}} test email.",
  "Sent {{count}} test emails._other": "Sent {{count}} test emails.",
  "Sent/Scheduled this month: {{used}} of {{limit}}": "Sent/Scheduled this month: {{used}} of {{limit}}",
  "Setting up this information will save it for future campaigns, autopopulating it without the need to edit.": "Setting up this information will save it for future campaigns, autopopulating it without the need to edit.",
  "Settings successfully updated.": "Settings successfully updated.",
  "Skip": "Skip",
  "Something went wrong: ": "Something went wrong: ",
  "Start Over": "Start Over",
  "Start from Scratch": "Start from Scratch",
  "Subject": "Subject",
  "Successfully Updated": "Successfully Updated",
  "Successfully created filter.": "Successfully created filter.",
  "Successfully deleted filter. ": "Successfully deleted filter. ",
  "Successfully deleted media.": "Successfully deleted media.",
  "Successfully deleted scheduled campaign.": "Successfully deleted scheduled campaign.",
  "Successfully rescheduled campaign.": "Successfully rescheduled campaign.",
  "Successfully updated filter. ": "Successfully updated filter. ",
  "Suggestions:": "Suggestions:",
  "Supported image formats are .jpg, .jpeg, .png, and .img. PDF files are not supported. Files cannot exceed 10MB.": "Supported image formats are .jpg, .jpeg, .png, and .img. PDF files are not supported. Files cannot exceed 10MB.",
  "Taking into account the data you gave, I've prepared this email campaign. What are your thoughts on it?": "Taking into account the data you gave, I've prepared this email campaign. What are your thoughts on it?",
  "Target specific groups for your email marketing campaigns with Weave's filters.": "Target specific groups for your email marketing campaigns with Weave's filters.",
  "Template Name": "Template Name",
  "Template Preview": "Template Preview",
  "Template Preview: {{name}}": "Template Preview: {{name}}",
  "Template successfully updated": "Template successfully updated",
  "Templated document": "Templated document",
  "Templates": "Templates",
  "The csv was not formatted correctly. Download the example file below to get started.": "The csv was not formatted correctly. Download the example file below to get started.",
  "The template preview is not currently available.": "The template preview is not currently available.",
  "This can't be undone": "This can't be undone",
  "This filter has no criteria. It will select all recipients.": "This filter has no criteria. It will select all recipients.",
  "This template has already been sent.": "This template has already been sent.",
  "Time": "Time",
  "Today at 1:00pm": "Today at 1:00pm",
  "Tomorrow at 8:00am": "Tomorrow at 8:00am",
  "Undo": "Undo",
  "Unindent": "Unindent",
  "Unsubscribed": "Unsubscribed",
  "Untitled": "Untitled",
  "Update Your Company Logo": "Update Your Company Logo",
  "Upload": "Upload",
  "Upload Recipients": "Upload Recipients",
  "Upload file on computer": "Upload file on computer",
  "Uploaded Successfully!": "Uploaded Successfully!",
  "Use Template": "Use Template",
  "View": "View",
  "Watch the video below to learn more about creating and using email filters.": "Watch the video below to learn more about creating and using email filters.",
  "Weave AI": "Weave AI",
  "Weave Gallery": "Weave Gallery",
  "Weave Premade Templates": "Weave Premade Templates",
  "Weave templates": "Weave templates",
  "Wednesday at 8:00am": "Wednesday at 8:00am",
  "Would you like to start a new campaign with this template?": "Would you like to start a new campaign with this template?",
  "You can create as many filters as you'd like and then reuse any of them on future campaigns. It is as easy as 1-2-3!": "You can create as many filters as you'd like and then reuse any of them on future campaigns. It is as easy as 1-2-3!",
  "You have no email sends remaining": "You have no email sends remaining",
  "You will send this campaign to <1>{{recipientCount}} recipients.</1>": "You will send this campaign to <1>{{recipientCount}} recipients.</1>",
  "You will send this campaign to <1>{{recipientCount}} recipients</1><2></2>on <5>{{date}} at {{time}}.</5>_one": "You will send this campaign to <1>{{recipientCount}} recipient</1><2></2>on <5>{{date}} at {{time}}.</5>",
  "You will send this campaign to <1>{{recipientCount}} recipients</1><2></2>on <5>{{date}} at {{time}}.</5>_other": "You will send this campaign to <1>{{recipientCount}} recipients</1><2></2>on <5>{{date}} at {{time}}.</5>",
  "Your Images": "Your Images",
  "Your Templates": "Your Templates",
  "Your templates": "Your templates",
  "click to upload": "click to upload",
  "this filter": "this filter",
  "{{count}} Recipients Selected_one": "{{count}} Recipient Selected",
  "{{count}} Recipients Selected_other": "{{count}} Recipients Selected",
  "{{count}} recipients imported_one": "{{count}} recipients imported",
  "{{count}} recipients imported_other": "{{count}} recipients imported",
  "{{count}} {{fileCount}} rejected. Only image files are allowed._one": "{{count}} {{fileCount}} rejected. Only image files are allowed.",
  "{{count}} {{fileCount}} rejected. Only image files are allowed._other": "{{count}} {{fileCount}} rejected. Only image files are allowed.",
  "{{hoverLabel}}": "{{hoverLabel}}",
  "{{name}}": "{{name}}",
  "{{remaining}} campaigns left for {{date}}": "{{remaining}} campaigns left for {{date}}"
}
